import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
const MapShimmer = ({
  width,
  height,
  borderRadius,
  userType,
}: {
  width: string;
  height: string;
  borderRadius: string;
  userType: "RegenAg" | "ARR" | "";
}) => {
  return (
    <Grid
      item
      xs={12}
      md={userType === "ARR" || userType === "" ? 12 : 9}
      lg={userType === "ARR" || userType === "" ? 12 : 9}
      data-testid="map-shimmer"
      data-tut="map-container"
    >
      <Skeleton
        animation="wave"
        width={width}
        height={height}
        sx={{
          borderRadius,
        }}
        variant="rectangular"
      />
    </Grid>
  );
};
export default MapShimmer;
